import { createGetApi, createPostApi } from 'friday-async';

class Apis {
  public list = createGetApi<void>({
    url: '/banner/list',
  });

  public create = createPostApi<{
    title: string;
    imageUrl: string;
    linkUrl?: string;
    enableJump?: boolean;
    sortOrder?: number;
    status?: string;
  }>({
    url: '/banner/create',
  });

  public update = createPostApi<{
    _id: string;
    title: string;
    imageUrl: string;
    linkUrl?: string;
    enableJump?: boolean;
    sortOrder?: number;
    status?: string;
  }>({
    url: '/banner/update',
  });

  public remove = createPostApi<{_id: string}>({
    url: '/banner/remove',
  });
}

export default Apis;
